import styles from './style.module.scss'

export const MainBackground = () => {

    return(
        <div className={styles.background} id={"home"}/>
    )
}